import React, { useState } from 'react';
import Header from '../components/Header';
import { users, trucks, deliveries } from '../data/mockData';

const AdminPanel: React.FC = () => {
  const [activeTab, setActiveTab] = useState('dashboard');
  
  return (
    <div className="min-h-screen bg-gray-100">
      <Header />
      
      <main className="container mx-auto px-4 py-8">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold text-gray-800">Administration</h1>
          <div className="flex space-x-2">
            <button className="px-4 py-2 bg-blue-600 border border-transparent rounded-md shadow-sm text-sm font-medium text-white hover:bg-blue-700">
              Exporter les données
            </button>
          </div>
        </div>
        
        {/* Onglets de navigation */}
        <div className="bg-white rounded-lg shadow-md mb-6">
          <div className="border-b border-gray-200">
            <nav className="flex -mb-px">
              <button
                onClick={() => setActiveTab('dashboard')}
                className={`py-4 px-6 text-center border-b-2 font-medium text-sm ${
                  activeTab === 'dashboard'
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                Tableau de bord
              </button>
              <button
                onClick={() => setActiveTab('users')}
                className={`py-4 px-6 text-center border-b-2 font-medium text-sm ${
                  activeTab === 'users'
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                Utilisateurs
              </button>
              <button
                onClick={() => setActiveTab('trucks')}
                className={`py-4 px-6 text-center border-b-2 font-medium text-sm ${
                  activeTab === 'trucks'
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                Camions
              </button>
              <button
                onClick={() => setActiveTab('deliveries')}
                className={`py-4 px-6 text-center border-b-2 font-medium text-sm ${
                  activeTab === 'deliveries'
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                Livraisons
              </button>
              <button
                onClick={() => setActiveTab('settings')}
                className={`py-4 px-6 text-center border-b-2 font-medium text-sm ${
                  activeTab === 'settings'
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                Paramètres
              </button>
            </nav>
          </div>
        </div>
        
        {/* Contenu de l'onglet */}
        <div className="bg-white rounded-lg shadow-md p-6">
          {activeTab === 'dashboard' && (
            <div>
              <h2 className="text-lg font-medium text-gray-900 mb-6">Statistiques générales</h2>
              
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                  <h3 className="text-sm font-medium text-gray-500">Total des utilisateurs</h3>
                  <p className="mt-1 text-3xl font-semibold text-gray-900">{users.length}</p>
                  <div className="mt-1">
                    <span className="text-green-600 text-sm font-medium">+12.5%</span>
                    <span className="text-gray-500 text-sm ml-1">depuis le mois dernier</span>
                  </div>
                </div>
                
                <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                  <h3 className="text-sm font-medium text-gray-500">Total des camions</h3>
                  <p className="mt-1 text-3xl font-semibold text-gray-900">{trucks.length}</p>
                  <div className="mt-1">
                    <span className="text-green-600 text-sm font-medium">+5.0%</span>
                    <span className="text-gray-500 text-sm ml-1">depuis le mois dernier</span>
                  </div>
                </div>
                
                <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                  <h3 className="text-sm font-medium text-gray-500">Total des livraisons</h3>
                  <p className="mt-1 text-3xl font-semibold text-gray-900">{deliveries.length}</p>
                  <div className="mt-1">
                    <span className="text-green-600 text-sm font-medium">+18.2%</span>
                    <span className="text-gray-500 text-sm ml-1">depuis le mois dernier</span>
                  </div>
                </div>
              </div>
              
              <div className="mb-8">
                <h3 className="text-lg font-medium text-gray-900 mb-4">Intégration avec LORIE</h3>
                <div className="bg-green-50 border border-green-200 rounded-md p-4">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <svg className="h-5 w-5 text-green-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <div className="ml-3">
                      <h3 className="text-sm font-medium text-green-800">Connexion active</h3>
                      <div className="mt-2 text-sm text-green-700">
                        <p>La connexion avec le logiciel LORIE est active et fonctionne correctement. Dernière synchronisation : il y a 5 minutes.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="mb-8">
                <h3 className="text-lg font-medium text-gray-900 mb-4">Activité récente</h3>
                <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
                  <table className="min-w-full divide-y divide-gray-300">
                    <thead className="bg-gray-50">
                      <tr>
                        <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">Action</th>
                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Utilisateur</th>
                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Date</th>
                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Détails</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200 bg-white">
                      <tr>
                        <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">Mise à jour du poids</td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">Sophie Martin</td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">15/04/2025 10:15</td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">Livraison #2: 4800 kg</td>
                      </tr>
                      <tr>
                        <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">Envoi de SMS</td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">Thomas Durand</td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">15/04/2025 10:05</td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">Client: Entreprise Dupont</td>
                      </tr>
                      <tr>
                        <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">Livraison terminée</td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">Pierre Dubois</td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">15/04/2025 09:45</td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">Livraison #3: Constructions Leroy</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
          
          {activeTab === 'users' && (
            <div>
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-lg font-medium text-gray-900">Gestion des utilisateurs</h2>
                <button className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors">
                  Ajouter un utilisateur
                </button>
              </div>
              
              <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
                <table className="min-w-full divide-y divide-gray-300">
                  <thead className="bg-gray-50">
                    <tr>
                      <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">ID</th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Nom</th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Rôle</th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Téléphone</th>
                      <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
                        <span className="sr-only">Actions</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white">
                    {users.map((user) => (
                      <tr key={user.id}>
                        <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">#{user.id}</td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                          <div className="flex items-center">
                            <img src={user.avatar} alt={user.name} className="h-8 w-8 rounded-full mr-3" />
                            {user.name}
                          </div>
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                          <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${
                            user.role === 'administrateur' ? 'bg-purple-100 text-purple-800' : 'bg-blue-100 text-blue-800'
                          }`}>
                            {user.role}
                          </span>
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{user.phone}</td>
                        <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                          <button className="text-blue-600 hover:text-blue-900 mr-4">Modifier</button>
                          <button className="text-red-600 hover:text-red-900">Supprimer</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          
          {activeTab === 'trucks' && (
            <div>
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-lg font-medium text-gray-900">Gestion des camions</h2>
                <button className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors">
                  Ajouter un camion
                </button>
              </div>
              
              <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
                <table className="min-w-full divide-y divide-gray-300">
                  <thead className="bg-gray-50">
                    <tr>
                      <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">ID</th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Immatriculation</th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Chauffeur</th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Statut</th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Poids chargé</th>
                      <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
                        <span className="sr-only">Actions</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white">
                    {trucks.map((truck) => {
                      const driver = users.find(u => u.id === truck.driverId);
                      return (
                        <tr key={truck.id}>
                          <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">#{truck.id}</td>
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{truck.licensePlate}</td>
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                            {driver ? driver.name : 'Non assigné'}
                          </td>
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                            <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${
                              truck.status === 'en_route' ? 'bg-green-100 text-green-800' : 
                              truck.status === 'chargement' ? 'bg-blue-100 text-blue-800' : 
                              truck.status === 'déchargement' ? 'bg-orange-100 text-orange-800' : 
                              'bg-gray-100 text-gray-800'
                            }`}>
                              {truck.status.replace('_', ' ')}
                            </span>
                          </td>
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{truck.loadWeight} kg</td>
                          <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                            <button className="text-blue-600 hover:text-blue-900 mr-4">Modifier</button>
                            <button className="text-red-600 hover:text-red-900">Supprimer</button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          
          {activeTab === 'deliveries' && (
            <div>
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-lg font-medium text-gray-900">Gestion des livraisons</h2>
                <button className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors">
                  Ajouter une livraison
                </button>
              </div>
              
              <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
                <table className="min-w-full divide-y divide-gray-300">
                  <thead className="bg-gray-50">
                    <tr>
                      <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">ID</th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Client</th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Camion</th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Statut</th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Heure prévue</th>
                      <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
                        <span className="sr-only">Actions</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white">
                    {deliveries.map((delivery) => {
                      const truck = trucks.find(t => t.id === delivery.truckId);
                      return (
                        <tr key={delivery.id}>
                          <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">#{delivery.id}</td>
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{delivery.clientName}</td>
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                            {truck ? `#${truck.id} (${truck.licensePlate})` : 'Non assigné'}
                          </td>
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                            <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${
                              delivery.status === 'en_cours' ? 'bg-green-100 text-green-800' : 
                              delivery.status === 'en_attente' ? 'bg-yellow-100 text-yellow-800' : 
                              delivery.status === 'terminée' ? 'bg-gray-100 text-gray-800' : 
                              'bg-blue-100 text-blue-800'
                            }`}>
                              {delivery.status.replace('_', ' ')}
                            </span>
                          </td>
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                            {new Date(delivery.scheduledTime).toLocaleTimeString('fr-FR', { 
                              hour: '2-digit', 
                              minute: '2-digit' 
                            })}
                          </td>
                          <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                            <button className="text-blue-600 hover:text-blue-900 mr-4">Modifier</button>
                            <button className="text-red-600 hover:text-red-900">Supprimer</button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          
          {activeTab === 'settings' && (
            <div>
              <h2 className="text-lg font-medium text-gray-900 mb-6">Paramètres du système</h2>
              
              <div className="space-y-6">
                <div className="bg-white shadow sm:rounded-lg">
                  <div className="px-4 py-5 sm:p-6">
                    <h3 className="text-lg leading-6 font-medium text-gray-900">Configuration de l'API LORIE</h3>
                    <div className="mt-2 max-w-xl text-sm text-gray-500">
                      <p>Configurez les paramètres de connexion à l'API LORIE pour synchroniser les données.</p>
                    </div>
                    <form className="mt-5 sm:flex sm:items-center">
                      <div className="w-full sm:max-w-xs">
                        <label htmlFor="api-key" className="sr-only">Clé API</label>
                        <input
                          type="text"
                          name="api-key"
                          id="api-key"
                          className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                          placeholder="Clé API LORIE"
                          defaultValue="••••••••••••••••"
                        />
                      </div>
                      <button
                        type="submit"
                        className="mt-3 w-full inline-flex items-center justify-center px-4 py-2 border border-transparent shadow-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                      >
                        Mettre à jour
                      </button>
                    </form>
                  </div>
                </div>
                
                <div className="bg-white shadow sm:rounded-lg">
                  <div className="px-4 py-5 sm:p-6">
                    <h3 className="text-lg leading-6 font-medium text-gray-900">Configuration des notifications SMS</h3>
                    <div className="mt-2 max-w-xl text-sm text-gray-500">
                      <p>Configurez les modèles de messages SMS envoyés aux clients.</p>
                    </div>
                    <div className="mt-5">
                      <div>
                        <label htmlFor="sms-template" className="block text-sm font-medium text-gray-700">
                          Modèle SMS de notification de départ
                        </label>
                        <div className="mt-1">
                          <textarea
                            id="sms-template"
                            name="sms-template"
                            rows={3}
                            className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border border-gray-300 rounded-md"
                            defaultValue="Bonjour, votre livraison est en route. Heure d'arrivée estimée: {ETA}. Suivez votre livraison en direct: {TRACKING_URL}"
                          />
                        </div>
                      </div>
                      <div className="mt-4">
                        <label htmlFor="sms-variables" className="block text-sm font-medium text-gray-700">
                          Variables disponibles
                        </label>
                        <div className="mt-1 text-sm text-gray-500">
                          <code className="bg-gray-100 px-1 py-0.5 rounded">{'{CLIENT_NAME}'}</code>,
                          <code className="bg-gray-100 px-1 py-0.5 rounded ml-1">{'{ETA}'}</code>,
                          <code className="bg-gray-100 px-1 py-0.5 rounded ml-1">{'{TRACKING_URL}'}</code>,
                          <code className="bg-gray-100 px-1 py-0.5 rounded ml-1">{'{DRIVER_NAME}'}</code>
                        </div>
                      </div>
                      <button
                        type="button"
                        className="mt-4 inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                      >
                        Enregistrer
                      </button>
                    </div>
                  </div>
                </div>
                
                <div className="bg-white shadow sm:rounded-lg">
                  <div className="px-4 py-5 sm:p-6">
                    <h3 className="text-lg leading-6 font-medium text-gray-900">Paramètres de géolocalisation</h3>
                    <div className="mt-2 max-w-xl text-sm text-gray-500">
                      <p>Configurez les paramètres de mise à jour de la géolocalisation des camions.</p>
                    </div>
                    <div className="mt-5 space-y-4">
                      <div>
                        <label htmlFor="update-frequency" className="block text-sm font-medium text-gray-700">
                          Fréquence de mise à jour (secondes)
                        </label>
                        <div className="mt-1">
                          <input
                            type="number"
                            name="update-frequency"
                            id="update-frequency"
                            className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                            defaultValue="30"
                            min="5"
                            max="300"
                          />
                        </div>
                      </div>
                      <div className="flex items-start">
                        <div className="flex items-center h-5">
                          <input
                            id="optimize-battery"
                            name="optimize-battery"
                            type="checkbox"
                            className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded"
                            defaultChecked
                          />
                        </div>
                        <div className="ml-3 text-sm">
                          <label htmlFor="optimize-battery" className="font-medium text-gray-700">
                            Optimiser pour l'économie de batterie
                          </label>
                          <p className="text-gray-500">Réduit la fréquence des mises à jour lorsque le camion est à l'arrêt.</p>
                        </div>
                      </div>
                      <button
                        type="button"
                        className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                      >
                        Enregistrer
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

export default AdminPanel;
